export class PlanLibraryInfo {
  constructor(
    public id: string, // ライブラリID
    public contentsIdList: number[], // コンテンツIDリスト
  ) {}

  public static empty(): PlanLibraryInfo {
    return new PlanLibraryInfo("", []);
  }
}

// Firestore data converter
export const PlanLibraryInfoConverter = {
  toFirestore: (item: any) => {
    return {
      contents_id_list: item.contentsIdList,
    };
  },
  fromFirestore: (snapshot: any, options: any) => {
    const data = snapshot.data(options);
    return new PlanLibraryInfo(snapshot.id, data.contents_id_list);
  },
};
